import React from "react";
import { Typography } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
const { Title, Text } = Typography;

export const HelpApplicationSubscription = () => {
  return (
    <>
      <Title level={5}>
        <QuestionCircleOutlined />
        &nbsp;Configuring your Application Subscription Settings
      </Title>
      <ul>
        <li>
          <Text type="danger">Subscribed Role (Mandatory):</Text> Role used for
          Subscribed people.
          <br />
          People with this role will be subscribed to the application (if
          eligibility also applies).
          <br />
          The Role can be configured:
          <ul>
            <li>
              Without Group: Role applies to all authenticated users, everyone
              will be subscribed to the application
            </li>
            <li>
              With Group: one (or multiple recursive) groups, static or dynamic,
              with or without moderator membership approval.
            </li>
          </ul>
          <i>
            Example: Subscribed Role is mapped to a Subscribed Group containing
            one dynamic group &quot;atlas-users&quot; and one static group
            &quot;atlas-guests&quot; with self-subscription and moderator
            approval where users outside &quot;atlas-users&quot; will be added
            if they click &quot;Subscribe&quot; button.
          </i>
        </li>
        <li>
          <Text>Subscription Group:</Text> The group belonging to the Subscribed
          Role where people will be self-added when clicking Subscribe button
          (&quot;atlas-guests&quot; in the example above).
          <br />
          If not set, users not in the Subscribed Role will not be able to
          Subscribe to the Service.
        </li>
        <li>
          <Text type="secondary">Denied RoleId:</Text> People denied access to
          this application. Mostly for Security aspects.
        </li>
        <li>
          <Text type="secondary">Admin RoleId:</Text> People with admin rights
          to this application.
        </li>
        <li>
          <Text type="secondary">Grace Period Days:</Text> Grace period, after
          unsubscribe or eligiliby lost, during which the service is still
          accessible (default=0).
        </li>
      </ul>
    </>
  );
};
